<mat-stepper linear #stepper>
  <mat-step [stepControl]="firstStepSetupForm" [formGroup]="firstStepSetupForm" [editable]="true">
    <ng-template matStepLabel>Main Data</ng-template>

    <div class="setup-intro">
      <p>
        Use this tile to feature a headline, supporting copy, datasource total, and a hero image.
        Configure the main content first, then add the action buttons in the next step.
      </p>
    </div>

    <div class="inputs-container">
      <mat-form-field appearance="fill">
        <mat-label>Heading</mat-label>
        <input matInput formControlName="heading" />
        <mat-hint>Sets the main banner headline.</mat-hint>
        <mat-error *ngIf="headingControl.hasError('required')">Heading is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Sub Heading</mat-label>
        <input matInput formControlName="subHeading" />
        <mat-hint>Adds supporting text below the main headline.</mat-hint>
        @if (subHeadingControl.hasError('required')) {
          <mat-error>Sub Heading is required</mat-error>
        }
      </mat-form-field>

      <app-data-source-selector
        formControlName="displayFeatureTotal"
        hint="Chooses the datasource used for the featured total shown in the banner."
        (onDataSourceChange)="initDataSource($event)"
      ></app-data-source-selector>

      <mat-form-field appearance="fill">
        <mat-label>Heading Icon</mat-label>
        <input matInput formControlName="headingIcon" />
        <mat-hint>Sets the icon shown alongside the banner heading.</mat-hint>
        @if (headingIconControl.hasError('required')) {
          <mat-error>Heading Icon is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Image URI</mat-label>
        <input matInput formControlName="imgUri" />
        <mat-hint>Defines the main image displayed in the banner.</mat-hint>
        <mat-error *ngIf="imgUriControl.hasError('required')">Image URI is required</mat-error>
      </mat-form-field>
    </div>

    <div>
      <button mat-button matStepperNext (click)="firstStepSetupForm.markAllAsTouched()">
        Next
      </button>
    </div>
  </mat-step>

  <mat-step [stepControl]="secondStepSetupForm" [formGroup]="secondStepSetupForm">
    <ng-template matStepLabel>Link Buttons</ng-template>

    <p class="section-intro">
      Add one or more buttons and define the text, icon, theme, and route each one should use.
    </p>

    <ng-container *ngFor="let linkButton of linkButtonsControl.controls; let i = index">
      <div [formGroup]="linkButton">
        <div class="inputs-container">
          <mat-form-field appearance="fill">
            <mat-label>Text</mat-label>
            <input matInput formControlName="buttonText" />
            <mat-hint>Sets the button label shown to the user.</mat-hint>
            @if (linkButton.get('buttonText').hasError('required')) {
              <mat-error>Text is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Icon</mat-label>
            <input matInput formControlName="buttonIcon" />
            <mat-hint>Sets the icon displayed inside the button.</mat-hint>
            @if (linkButton.get('buttonIcon').hasError('required')) {
              <mat-error>Icon is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Color Theme</mat-label>
            <input matInput formControlName="buttonColorTheme" />
            <mat-hint>Chooses the theme key used to style the button.</mat-hint>
            <mat-error *ngIf="linkButton.get('buttonColorTheme').hasError('required')">
              Color Theme is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Route Link</mat-label>
            <input matInput formControlName="routeLink" />
            <mat-hint>Sets the route the button should open when clicked.</mat-hint>
            @if (linkButton.get('routeLink').hasError('required')) {
              <mat-error>Route Link is required</mat-error>
            }
          </mat-form-field>

          <mat-icon class="delete-btn" (click)="removeLinkButton(i)">delete_forever</mat-icon>
        </div>
      </div>
    </ng-container>

    <button class="add-link-btn" mat-raised-button color="primary" (click)="addLinkButton()">
      Add Link Button
    </button>

    <div>
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button matStepperNext (click)="secondStepSetupForm.markAllAsTouched()">
        Next
      </button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Confirm</ng-template>
    <p>Title: {{ headingControl.value }}</p>
    <p>Sub Heading: {{ subHeadingControl.value }}</p>
    <p>Display Feature Total: {{ dataSourceObject?.name }}</p>
    <p>Heading Icon: {{ headingIconControl.value }}</p>
    <p>Image URI: {{ imgUriControl.value }}</p>

    <div *ngFor="let linkButton of linkButtonsControl.controls">
      <span>Text: {{ linkButton.get('buttonText').value }}</span>
      <span>Icon: {{ linkButton.get('buttonIcon').value }}</span>
      <span>Color Theme: {{ linkButton.get('buttonColorTheme').value }}</span>
      <span>Route Link: {{ linkButton.get('routeLink').value }}</span>
    </div>

    <div>
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button (click)="onCreate()">Apply</button>
    </div>
  </mat-step>
</mat-stepper>
